/* ============================================================================
FILE: po-katupirsia9-cycle-posoennoial-texts-fr-en-es-20260328.js
MODE: protected trilingual with FR / EN / ES buttons + canonical lexicon preserved
API:  window.PoKatupirsia9CyclePosoennoialTextsFR_EN_ES_20260328
ROOT: .po-axis-section[data-po-axis='cycle_posoennoial']
ROLE:
  - Langue pilotée par localStorage : po_lex_lang + compat goody_gp_lang
  - Injection trilingue FR / EN / ES dans les slots
  - Protection fine du lexique canonique FR (avec variantes œ/oe, apostrophes)
  - Couche audio locale par bloc + lecture générale, greffée sans casser la logique existante
  - Multi-instances OK
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_KATUPIRSIA9_CYCLE_POSOENNOIAL_TEXTS_20260328__) return;
  window.__PO_KATUPIRSIA9_CYCLE_POSOENNOIAL_TEXTS_20260328__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = ".po-axis-section[data-po-axis='cycle_posoennoial']";

  var CONCEPT_URL  = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Cycle_posoennoial_conceptuel.png?v=1773269473";
  var FUNCTION_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Cycle_posoennoial_fonctionnel.png?v=1773269473";
  var PAGE_URL     = "https://goodyart.store/pages/cycle-posoennoial";

  var CANON_TERMS_FALLBACK = [
    "Cycle posœnnoïal",
    "Décade",
    "Mois posœnnoïal",
    "Année posœnnoïale",
    "Année posœnnoïale (AP)",
    "AP",
    "Épagomènes",
    "Épagomène",
    "Δτ",
    "Souffle d’Or",
    "Katûpirsia",
    "Àṣẹxel’Or",
    "Humanus",
    "Numéris",
    "RéZonans",
    "Posœnnoïa",
    "Posœnnoïal",
    "Posœnnoïsme",
    "Idéogramme conceptuel",
    "Idéogramme fonctionnel"
  ];

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "ES";
    if (s.indexOf("en") === 0) return "EN";
    return "FR";
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return v ? normLang(v) : "";
  }

  function storeLang(lang3){
    var lang = normLang(lang3);
    try{ localStorage.setItem(STORAGE_KEY, lang); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, lang); }catch(_e){}
    try{ document.documentElement.setAttribute("lang", lang.toLowerCase()); }catch(__e){}
    return lang;
  }

  function getBrowserLang(){
    var dl = document && document.documentElement ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    if (typeof navigator !== "undefined"){
      if (navigator.languages && navigator.languages.length) return normLang(navigator.languages[0] || "fr");
      if (navigator.language) return normLang(navigator.language || "fr");
    }
    return "FR";
  }

  function getLang(){
    return readStoredLang() || getBrowserLang() || "FR";
  }

  function notifyLocaleChanged(){
    try{ window.dispatchEvent(new Event("po:locale-changed")); }
    catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var key = clampStr(v).trim();
    if (!key || seen[key]) return;
    seen[key] = true;
    arr.push(key);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term).trim();
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);
    uniqPush(out, t.replace(/É/g, "E").replace(/é/g, "e"), seen);

    if (t.indexOf("/") > -1){
      t.split("/").forEach(function(part){
        buildVariants(part).forEach(function(v){ uniqPush(out, v, seen); });
      });
    }

    return out;
  }

  function getRuntimeLexiqueList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXIQUE_SIMPLIFIE && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE)){
        return window.PO_LEXIQUE_SIMPLIFIE.slice();
      }
    }catch(e){}
    return [];
  }

  function getCanonicalTerms(){
    var seen = Object.create(null);
    var out = [];
    CANON_TERMS_FALLBACK.forEach(function(term){ buildVariants(term).forEach(function(v){ uniqPush(out, v, seen); }); });
    getRuntimeLexiqueList().forEach(function(term){ buildVariants(term).forEach(function(v){ uniqPush(out, v, seen); }); });
    out.sort(function(a, b){ return b.length - a.length; });
    return out;
  }

  function getCanonicalRegex(){
    if (getCanonicalRegex._cache) return getCanonicalRegex._cache;
    var terms = getCanonicalTerms();
    if (!terms.length){
      getCanonicalRegex._cache = null;
      return null;
    }
    getCanonicalRegex._cache = new RegExp("(" + terms.map(escapeRegExp).join("|") + ")", "g");
    return getCanonicalRegex._cache;
  }

  function protectPlainTextSegment(text){
    var segment = clampStr(text);
    if (!segment) return "";
    var rx = getCanonicalRegex();
    if (!rx) return escapeHTML(segment);
    return escapeHTML(segment).replace(rx, function(m){
      return '<span class="notranslate" translate="no">' + m + '</span>';
    });
  }

  function protectHTML(html){
    var src = clampStr(html);
    if (!src) return "";
    var parts = src.split(/(<[^>]+>)/g);
    for (var i = 0; i < parts.length; i++){
      if (!parts[i] || /^<[^>]+>$/.test(parts[i])) continue;
      parts[i] = protectPlainTextSegment(parts[i]);
    }
    return parts.join("");
  }

  function protectTextNode(node){
    if (!node || !node.nodeValue) return;
    if (!node.parentNode) return;
    if (!node.nodeValue.trim()) return;
    if (node.parentNode.closest && node.parentNode.closest('.notranslate,[translate="no"],script,style,textarea')) return;

    var rx = getCanonicalRegex();
    if (!rx || !rx.test(node.nodeValue)) return;
    rx.lastIndex = 0;

    var text = node.nodeValue;
    var frag = document.createDocumentFragment();
    var lastIndex = 0;
    var match;

    while ((match = rx.exec(text))){
      if (match.index > lastIndex){
        frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
      }
      var span = document.createElement("span");
      span.className = "notranslate";
      span.setAttribute("translate", "no");
      span.textContent = match[0];
      frag.appendChild(span);
      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length){
      frag.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    node.parentNode.replaceChild(frag, node);
  }

  function protectDOM(root){
    if (!root || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    var current;
    while ((current = walker.nextNode())) nodes.push(current);
    nodes.forEach(protectTextNode);
  }

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = protectHTML(html);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.setAttribute("src", clampStr(src));
    el.setAttribute("alt", clampStr(alt));
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = "";
    (items || []).forEach(function(item){
      var li = document.createElement("li");
      li.innerHTML = protectHTML(item);
      el.appendChild(li);
    });
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    host.innerHTML = "";
    (blocks || []).forEach(function(b){
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";

      var h = document.createElement("div");
      h.className = "po-axis-wb__h";
      h.innerHTML = protectHTML((b || {}).head || "");

      var t = document.createElement("div");
      t.className = "po-axis-wb__t";
      t.innerHTML = protectHTML((b || {}).text || "");

      wrap.appendChild(h);
      wrap.appendChild(t);
      host.appendChild(wrap);
    });
  }

  var CONTENT = {
    FR: {
      title: "Cycle posœnnoïal",
      title_img: CONCEPT_URL,
      kicker: "Extrait du <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Respiration du temps, trilogie décade–mois–épagomènes et relance spiralée)",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Architecture respirante du temps : la Décade, le Mois posœnnoïal et les Épagomènes organisent un passage spiralé du souffle court au souffle ultime.",
      def_long: "<p>Dans <em>Katûpirsia&nbsp;9</em>, le Cycle posœnnoïal se comprend à partir de la trilogie opérative du temps : la Décade, le Mois posœnnoïal et les Épagomènes. Cette trilogie n’est pas un découpage arbitraire : elle émane de la logique 3–6–9 et donne au temps sa respiration lisible, habitable et transmutable.</p><p>La Décade agit comme souffle court : dix jours, cinq d’inspiration et cinq d’expiration. Le Mois posœnnoïal agit comme souffle majeur : trois Décades, soit trente jours, où la première initie, la deuxième stabilise, la troisième accomplit et ouvre vers la transmutation. Les Épagomènes agissent comme souffle ultime : des seuils hors-cycle qui redistribuent l’excédent et relancent l’année.</p><p>À l’échelle de l’Année posœnnoïale, ce cycle organise trente-six Décades, douze mois, cinq jours épagomènes et la redistribution du Δτ. Le corpus insiste sur le fait qu’il ne s’agit pas d’un temps linéaire, mais d’un temps vivant : chaque fin porte déjà sa relance, chaque rotation se referme sur une spirale plus vaste, et le retour n’est jamais répétition simple mais retour enrichi.</p><p>Le Cycle posœnnoïal peut ainsi être compris comme la forme humaine et praticable des cycles du vrai temps. Il relie la perception, la pratique, la mémoire et la cosmologie : souffle court pour régler, souffle majeur pour orienter, souffle ultime pour franchir le seuil et renaître.</p>",
      h_features: "Dynamiques opératives",
      h_questions: "Applications / repères",
      hint_fold: "déplier",
      h_family: "Liens systémiques",
      h_wordbuild: "Construction du terme",
      features: [
        "Trilogie opérative : Décade, Mois posœnnoïal et Épagomènes structurent le passage du temps.",
        "Logique 3–6–9 : le cycle se lit comme émergence, stabilisation, accomplissement et relance.",
        "Respiration lisible : souffle court, souffle majeur, souffle ultime composent une année habitable.",
        "Redistribution du Δτ : l’excédent n’est pas corrigé mécaniquement, il est redistribué comme souffle.",
        "Spirale non linéaire : la fin du cycle agit comme un retour augmenté et non comme une répétition fermée."
      ],
      questions: [
        "Où suis-je dans le cycle : en réglage fin, en orientation d’un régime, ou sur un seuil de redistribution ?",
        "Quelle unité éclaire le mieux la situation : Décade, Mois posœnnoïal ou Épagomène ?",
        "Le passage vécu relève-t-il d’une simple succession, ou d’une relance spiralée du temps ?",
        "Quel acte bref rend le cycle habitable ici : cadence, pause, redistribution, clôture, relance ?"
      ],
      example_box: "<div><strong>Ex.</strong> Lorsqu’une pratique s’ouvre dans une Décade, se stabilise dans un Mois posœnnoïal, puis trouve un seuil de redistribution dans un Épagomène, elle manifeste la logique du Cycle posœnnoïal.</div>",
      family_1: "<p><strong>Liens internes :</strong> le Cycle posœnnoïal se relie à l’Année posœnnoïale (AP), à la Décade, au Mois posœnnoïal, aux Épagomènes, à Δτ, à Humanus, à Numéris et à la triade 3–6–9.</p>",
      family_2: "<p><strong>Fonction systémique :</strong> dans K9, le Cycle posœnnoïal constitue la forme praticable des cycles du vrai temps. Il rend visible la respiration du temps humain tout en l’ouvrant vers le Souffle d’Or, vers les cycles supérieurs et vers la relance spiralée du vivant.</p>",
      word_blocks: [
        { head: "1) Cycle", text: "Rotation, retour, accomplissement et relance : le temps y circule comme respiration plutôt que comme ligne fermée." },
        { head: "2) Posœnnoïal", text: "Le terme inscrit le cycle dans l’écologie du corpus : un temps habité, réglable, transmutable et relié au Souffle d’Or." },
        { head: "3) Ensemble", text: "Cycle posœnnoïal désigne l’architecture respirante du temps lorsqu’elle devient lisible par unités, seuils et relances spiralées." }
      ],
      word_notes: [
        "Deux idéogrammes attestés : conceptuel et fonctionnel.",
        "Le titre reste canonique sur le site : les variantes trilingues servent à la médiation, pas à la substitution du lexique.",
        "Fonction : rendre le temps lisible, habitable et transmutable par respiration du cycle.",
        "Liens majeurs : AP, Décade, Mois posœnnoïal, Épagomènes, Δτ."
      ],
      cta_translate: "Proposer une traduction du concept"
    },
    EN: {
      title: "Cycle posœnnoïal",
      title_img: CONCEPT_URL,
      kicker: "Excerpt from <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Breath of time, trilogy of Décade–Mois posœnnoïal–Épagomènes and spiral relaunch)",
      h_def: "Operative definition",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Breathing architecture of time: Décade, Mois posœnnoïal and Épagomènes organize a spiral passage from short breath to ultimate breath.",
      def_long: "<p>In <em>Katûpirsia&nbsp;9</em>, the Cycle posœnnoïal is understood through the operative trilogy of time: Décade, Mois posœnnoïal, and Épagomènes. This trilogy is not an arbitrary découpage: it proceeds from the logic of 3–6–9 and gives time a readable, inhabitable, and transmutable respiration.</p><p>Décade acts as short breath: ten days, five of in-breath and five of out-breath. Mois posœnnoïal acts as major breath: three Décades, that is, thirty days, where the first initiates, the second stabilizes, and the third accomplishes and opens toward transmutation. Épagomènes act as ultimate breath: out-of-cycle thresholds that redistribute the excess and relaunch the year.</p><p>At the scale of the Année posœnnoïale, this cycle organizes thirty-six Décades, twelve months, five epagomenal days, and the redistribution of Δτ. The corpus insists that this is not linear time but living time: every ending already bears its relaunch, every rotation closes upon a wider spiral, and return is never simple repetition but enriched return.</p><p>The Cycle posœnnoïal can therefore be understood as the human and practicable form of the cycles of true time. It links perception, practice, memory, and cosmology: short breath to tune, major breath to orient, ultimate breath to cross the threshold and be reborn.</p>",
      h_features: "Operative dynamics",
      h_questions: "Applications / markers",
      hint_fold: "expand",
      h_family: "Systemic links",
      h_wordbuild: "Term construction",
      features: [
        "Operative trilogy: Décade, Mois posœnnoïal and Épagomènes structure the passage of time.",
        "3–6–9 logic: the cycle is read as emergence, stabilization, accomplishment, and relaunch.",
        "Readable respiration: short breath, major breath, and ultimate breath compose an inhabitable year.",
        "Redistribution of Δτ: the excess is not mechanically corrected but redistributed as breath.",
        "Non-linear spiral: the end of the cycle acts as augmented return rather than closed repetition."
      ],
      questions: [
        "Where am I in the cycle: in fine tuning, in orientation of a regime, or on a threshold of redistribution?",
        "Which unit illuminates the situation best: Décade, Mois posœnnoïal, or Épagomène?",
        "Does the passage lived belong to simple succession, or to a spiral relaunch of time?",
        "Which brief act makes the cycle inhabitable here: cadence, pause, redistribution, closure, relaunch?"
      ],
      example_box: "<div><strong>Ex.</strong> When a practice opens within a Décade, stabilizes in a Mois posœnnoïal, then finds a threshold of redistribution in an Épagomène, it manifests the logic of the Cycle posœnnoïal.</div>",
      family_1: "<p><strong>Internal links:</strong> the Cycle posœnnoïal connects with Année posœnnoïale (AP), Décade, Mois posœnnoïal, Épagomènes, Δτ, Humanus, Numéris, and the triad 3–6–9.</p>",
      family_2: "<p><strong>Systemic function:</strong> in K9, the Cycle posœnnoïal constitutes the practicable form of the cycles of true time. It makes the respiration of human time visible while opening it toward the Souffle d’Or, toward higher cycles, and toward the spiral relaunch of the living.</p>",
      word_blocks: [
        { head: "1) Cycle", text: "Rotation, return, accomplishment, and relaunch: time circulates here as respiration rather than as a closed line." },
        { head: "2) Posœnnoïal", text: "The term inscribes the cycle within the ecology of the corpus: a time inhabited, adjustable, transmutable, and linked to the Souffle d’Or." },
        { head: "3) Whole", text: "Cycle posœnnoïal designates the breathing architecture of time when it becomes readable through units, thresholds, and spiral relaunches." }
      ],
      word_notes: [
        "Two attested ideograms: conceptual and functional.",
        "The title remains canonical on the site: the trilingual variants serve mediation, not substitution of the lexicon.",
        "Function: to make time readable, inhabitable, and transmutable through the respiration of the cycle.",
        "Major links: AP, Décade, Mois posœnnoïal, Épagomènes, Δτ."
      ],
      cta_translate: "Suggest a translation of the concept"
    },
    ES: {
      title: "Cycle posœnnoïal",
      title_img: CONCEPT_URL,
      kicker: "Extracto de <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Respiración del tiempo, trilogía Décade–Mois posœnnoïal–Épagomènes y relanzamiento espiral)",
      h_def: "Definición operativa",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Arquitectura respirante del tiempo: Décade, Mois posœnnoïal y Épagomènes organizan un paso espiral del aliento corto al aliento último.",
      def_long: "<p>En <em>Katûpirsia&nbsp;9</em>, el Cycle posœnnoïal se comprende a partir de la trilogía operativa del tiempo: Décade, Mois posœnnoïal y Épagomènes. Esta trilogía no es un recorte arbitrario: emana de la lógica 3–6–9 y da al tiempo una respiración legible, habitable y transmutable.</p><p>Décade actúa como aliento corto: diez días, cinco de inspiración y cinco de espiración. Mois posœnnoïal actúa como aliento mayor: tres Décades, es decir, treinta días, donde la primera inicia, la segunda estabiliza y la tercera cumple y abre hacia la transmutación. Épagomènes actúan como aliento último: umbrales fuera de ciclo que redistribuyen el exceso y relanzan el año.</p><p>A escala de la Année posœnnoïale, este ciclo organiza treinta y seis Décades, doce meses, cinco días epagoménicos y la redistribución de Δτ. El corpus insiste en que no se trata de un tiempo lineal sino de un tiempo vivo: cada final lleva ya su relanzamiento, cada rotación se cierra sobre una espiral más amplia, y el retorno nunca es repetición simple sino retorno enriquecido.</p><p>El Cycle posœnnoïal puede así comprenderse como la forma humana y practicable de los ciclos del tiempo verdadero. Vincula percepción, práctica, memoria y cosmología: aliento corto para ajustar, aliento mayor para orientar, aliento último para cruzar el umbral y renacer.</p>",
      h_features: "Dinámicas operativas",
      h_questions: "Aplicaciones / referencias",
      hint_fold: "desplegar",
      h_family: "Vínculos sistémicos",
      h_wordbuild: "Construcción del término",
      features: [
        "Trilogía operativa: Décade, Mois posœnnoïal y Épagomènes estructuran el paso del tiempo.",
        "Lógica 3–6–9: el ciclo se lee como emergencia, estabilización, cumplimiento y relanzamiento.",
        "Respiración legible: aliento corto, aliento mayor y aliento último componen un año habitable.",
        "Redistribución de Δτ: el exceso no se corrige mecánicamente, se redistribuye como aliento.",
        "Espiral no lineal: el final del ciclo actúa como retorno aumentado y no como repetición cerrada."
      ],
      questions: [
        "¿Dónde estoy en el ciclo: en ajuste fino, en orientación de un régimen o en un umbral de redistribución?",
        "¿Qué unidad ilumina mejor la situación: Décade, Mois posœnnoïal o Épagomène?",
        "¿El paso vivido pertenece a una simple sucesión o a un relanzamiento espiral del tiempo?",
        "¿Qué acto breve vuelve habitable el ciclo aquí: cadencia, pausa, redistribución, cierre o relanzamiento?"
      ],
      example_box: "<div><strong>Ej.</strong> Cuando una práctica se abre en una Décade, se estabiliza en un Mois posœnnoïal y luego encuentra un umbral de redistribución en un Épagomène, manifiesta la lógica del Cycle posœnnoïal.</div>",
      family_1: "<p><strong>Vínculos internos:</strong> el Cycle posœnnoïal se vincula con Année posœnnoïale (AP), Décade, Mois posœnnoïal, Épagomènes, Δτ, Humanus, Numéris y la tríada 3–6–9.</p>",
      family_2: "<p><strong>Función sistémica:</strong> en K9, el Cycle posœnnoïal constituye la forma practicable de los ciclos del tiempo verdadero. Hace visible la respiración del tiempo humano y al mismo tiempo la abre hacia el Souffle d’Or, hacia ciclos superiores y hacia el relanzamiento espiral de lo vivo.</p>",
      word_blocks: [
        { head: "1) Cycle", text: "Rotación, retorno, cumplimiento y relanzamiento: el tiempo circula aquí como respiración y no como línea cerrada." },
        { head: "2) Posœnnoïal", text: "El término inscribe el ciclo en la ecología del corpus: un tiempo habitado, ajustable, transmutable y vinculado al Souffle d’Or." },
        { head: "3) Conjunto", text: "Cycle posœnnoïal designa la arquitectura respirante del tiempo cuando se vuelve legible por unidades, umbrales y relanzamientos espirales." }
      ],
      word_notes: [
        "Dos ideogramas atestiguados: conceptual y funcional.",
        "El título permanece canónico en el sitio: las variantes trilingües sirven para la mediación y no para sustituir el léxico.",
        "Función: volver legible, habitable y transmutable el tiempo por la respiración del ciclo.",
        "Vínculos mayores: AP, Décade, Mois posœnnoïal, Épagomènes, Δτ."
      ],
      cta_translate: "Proponer una traducción del concepto"
    }
  };

  function updateButtons(root, lang){
    var btns = root.querySelectorAll('.po-langbtn');
    Array.prototype.forEach.call(btns, function(btn){
      var active = normLang(btn.getAttribute('data-po-lang') || '') === lang;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function wireButtons(root){
    if (root.__po_lang_bound) return;
    root.__po_lang_bound = true;
    var btns = root.querySelectorAll('.po-langbtn');
    Array.prototype.forEach.call(btns, function(btn){
      btn.addEventListener('click', function(){
        applyLangEverywhere(normLang(btn.getAttribute('data-po-lang') || 'FR'));
      });
    });
  }

  var PO_AUDIO_SYNTH = (typeof window !== 'undefined' && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: '',
    lang: 'FR'
  };

  var AUDIO_UI = {
    FR: { general: 'Écouter le texte', block: 'Écouter ce bloc', stop: 'Arrêter la lecture' },
    EN: { general: 'Listen to the text', block: 'Listen to this section', stop: 'Stop playback' },
    ES: { general: 'Escuchar el texto', block: 'Escuchar este bloque', stop: 'Detener la lectura' }
  };

  function audioUI(lang){
    return AUDIO_UI[normLang(lang)] || AUDIO_UI.FR;
  }

  function ensureAudioStyles(){
    if (document.getElementById('po-cycle-audio-styles-20260328')) return;
    var style = document.createElement('style');
    style.id = 'po-cycle-audio-styles-20260328';
    style.textContent = [
      '.po-axis-audio-wrap{display:flex;justify-content:center;align-items:center;gap:8px;flex-wrap:wrap;margin:10px 0 12px;}',
      '.po-lex-summary .po-axis-audio-wrap{margin:0;justify-content:flex-end;}',
      '.po-axis-audio-btn{appearance:none;border:1px solid rgba(0,0,0,.14);background:rgba(255,255,255,.78);color:inherit;border-radius:999px;padding:6px 10px;font:inherit;font-size:12px;line-height:1.1;cursor:pointer;}',
      '.po-axis-audio-btn.is-playing{border-color:rgba(184,134,11,.55);box-shadow:0 0 0 1px rgba(184,134,11,.18);font-weight:700;}'
    ].join('');
    document.head.appendChild(style);
  }

  function createAudioButton(role, detailIndex){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-axis-audio-btn';
    btn.setAttribute('data-po-audio-role', role);
    if (detailIndex != null) btn.setAttribute('data-po-audio-index', String(detailIndex));
    return btn;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector('.po-lex-panel');
    if (panel){
      var generalWrap = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
      if (!generalWrap){
        generalWrap = document.createElement('div');
        generalWrap.className = 'po-axis-audio-wrap';
        generalWrap.setAttribute('data-po-audio-role', 'general');
        generalWrap.appendChild(createAudioButton('general'));

        var meta = root.querySelector('.po-axis-meta');
        var defShort = root.querySelector('[data-po-slot="def_short"]');
        var firstDetails = root.querySelector('.po-lex-details');
        if (meta && meta.parentNode === panel) meta.insertAdjacentElement('afterend', generalWrap);
        else if (defShort && defShort.parentNode === panel) defShort.insertAdjacentElement('beforebegin', generalWrap);
        else if (firstDetails && firstDetails.parentNode === panel) firstDetails.insertAdjacentElement('beforebegin', generalWrap);
        else panel.insertBefore(generalWrap, panel.firstChild);
      }
    }

    var details = root.querySelectorAll('.po-lex-details');
    Array.prototype.forEach.call(details, function(detail, idx){
      var summary = detail.querySelector('.po-lex-summary');
      if (!summary) return;
      var wrap = summary.querySelector('.po-axis-audio-wrap[data-po-audio-role="block"]');
      if (!wrap){
        wrap = document.createElement('span');
        wrap.className = 'po-axis-audio-wrap';
        wrap.setAttribute('data-po-audio-role', 'block');
        wrap.appendChild(createAudioButton('block', idx));
        summary.appendChild(wrap);
      }
    });

    refreshAudioButtons(root, lang);
    bindAudioEvents(root);
  }

  function refreshAudioButtons(root, lang){
    var ui = audioUI(lang);
    var btns = root.querySelectorAll('.po-axis-audio-btn');
    Array.prototype.forEach.call(btns, function(btn){
      var role = btn.getAttribute('data-po-audio-role');
      var isActive = PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === getButtonKey(btn);
      btn.classList.toggle('is-playing', !!isActive);
      btn.textContent = isActive ? ui.stop : (role === 'general' ? ui.general : ui.block);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function refreshAudioButtonsEverywhere(){
    var roots = document.querySelectorAll(ROOT_SEL);
    Array.prototype.forEach.call(roots, function(root){ refreshAudioButtons(root, getLang()); });
  }

  function bindAudioEvents(root){
    if (root.__po_audio_bound) return;
    root.__po_audio_bound = true;
    root.addEventListener('click', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('.po-axis-audio-btn') : null;
      if (!btn || !root.contains(btn)) return;
      ev.preventDefault();
      var role = btn.getAttribute('data-po-audio-role');
      var key = getButtonKey(btn);
      if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key){
        stopAudio();
        return;
      }
      if (role === 'general') startAudio(root, 0, 'general');
      else startAudio(root, parseInt(btn.getAttribute('data-po-audio-index') || '0', 10), 'block');
    });
  }

  function getButtonKey(btn){
    if (!btn) return '';
    var role = btn.getAttribute('data-po-audio-role') || '';
    var idx = btn.getAttribute('data-po-audio-index') || '';
    return role + ':' + idx;
  }

  function cleanText(text){
    return clampStr(text).replace(/\s+/g, ' ').replace(/\u00a0/g, ' ').trim();
  }

  function collectGeneralText(root){
    var parts = [];
    ['title', 'kicker', 'h_def', 'def_short', 'def_long'].forEach(function(slot){
      var el = root.querySelector('[data-po-slot="' + slot + '"]');
      if (el) parts.push(cleanText(el.textContent || ''));
    });
    return cleanText(parts.join('. '));
  }

  function collectBlockText(detail){
    if (!detail) return '';
    var parts = [];
    var summaryTitle = detail.querySelector('.po-lex-summary__title');
    if (summaryTitle) parts.push(cleanText(summaryTitle.textContent || ''));

    var clone = detail.cloneNode(true);
    var summary = clone.querySelector('summary');
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    Array.prototype.forEach.call(clone.querySelectorAll('.po-axis-audio-wrap,.po-axis-audio-btn'), function(n){
      if (n.parentNode) n.parentNode.removeChild(n);
    });
    parts.push(cleanText(clone.textContent || ''));
    return cleanText(parts.join('. '));
  }

  function splitSpeechChunks(text){
    var src = cleanText(text);
    if (!src) return [];
    var sentences = src.match(/[^.!?;:]+[.!?;:]?|[^.!?;:]+$/g) || [src];
    var chunks = [];
    var acc = '';

    sentences.forEach(function(sentence){
      var s = cleanText(sentence);
      if (!s) return;
      if (!acc){
        acc = s;
        return;
      }
      if ((acc + ' ' + s).length <= 210) acc += ' ' + s;
      else {
        chunks.push(acc);
        acc = s;
      }
    });

    if (acc) chunks.push(acc);
    return chunks.length ? chunks : [src];
  }

  function getVoiceLang(lang){
    var L = normLang(lang);
    if (L === 'EN') return 'en-US';
    if (L === 'ES') return 'es-ES';
    return 'fr-FR';
  }

  function chooseVoice(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_SYNTH.getVoices) return null;
    var target = getVoiceLang(lang).toLowerCase();
    var base = target.split('-')[0];
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    for (var i = 0; i < voices.length; i++){
      if ((voices[i].lang || '').toLowerCase() === target) return voices[i];
    }
    for (var j = 0; j < voices.length; j++){
      if ((voices[j].lang || '').toLowerCase().indexOf(base) === 0) return voices[j];
    }
    return null;
  }

  function openDetailIfNeeded(unit){
    if (!unit || unit.type !== 'block' || !unit.detail) return;
    unit.detail.open = true;
  }

  function speakCurrentUnit(){
    if (!PO_AUDIO_SYNTH) return;
    if (!PO_AUDIO_STATE.root) return;
    if (PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    openDetailIfNeeded(unit);
    var chunks = splitSpeechChunks(unit.text);
    if (!chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      speakCurrentUnit();
      return;
    }

    PO_AUDIO_STATE.chunks = chunks.slice();
    speakNextChunk();
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH) return;
    if (!PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
        stopAudio();
        return;
      }
      speakCurrentUnit();
      return;
    }

    var utter = new SpeechSynthesisUtterance(PO_AUDIO_STATE.chunks.shift());
    utter.lang = getVoiceLang(PO_AUDIO_STATE.lang);
    var voice = chooseVoice(PO_AUDIO_STATE.lang);
    if (voice) utter.voice = voice;
    utter.rate = 0.98;
    utter.pitch = 1;
    utter.onend = function(){ speakNextChunk(); };
    utter.onerror = function(){ speakNextChunk(); };
    PO_AUDIO_SYNTH.speak(utter);
  }

  function stopAudio(){
    if (PO_AUDIO_SYNTH){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = '';
    refreshAudioButtonsEverywhere();
  }

  function startAudio(root, startIndex, mode){
    if (!PO_AUDIO_SYNTH) return;
    stopAudio();

    var details = Array.prototype.slice.call(root.querySelectorAll('.po-lex-details'));
    var units = [];
    if (mode === 'general'){
      units.push({ type: 'general', text: collectGeneralText(root) });
      details.forEach(function(detail, idx){ units.push({ type: 'block', detail: detail, index: idx, text: collectBlockText(detail) }); });
      PO_AUDIO_STATE.activeKey = 'general:';
    } else {
      details.slice(startIndex).forEach(function(detail, offset){
        units.push({ type: 'block', detail: detail, index: startIndex + offset, text: collectBlockText(detail) });
      });
      PO_AUDIO_STATE.activeKey = 'block:' + String(startIndex);
    }

    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = units.filter(function(u){ return cleanText(u.text); });
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.lang = getLang();

    refreshAudioButtonsEverywhere();
    speakCurrentUnit();
  }

  if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.onvoiceschanged !== 'undefined'){
    PO_AUDIO_SYNTH.onvoiceschanged = function(){};
  }

  function renderRoot(root, lang){
    var T = CONTENT[lang] || CONTENT.FR;
    setSlotText(root, 'title', T.title);
    setSlotHTML(root, 'kicker', T.kicker);
    setSlotImgSrc(root, 'title_img', T.title_img || T.chip_urls[0], T.title);
    setSlotText(root, 'h_def', T.h_def);
    setSlotText(root, 'chip_1', T.chips[0]);
    setSlotText(root, 'chip_2', T.chips[1]);
    setSlotImgSrc(root, 'chip_1_img', T.chip_urls[0], T.chips[0]);
    setSlotImgSrc(root, 'chip_2_img', T.chip_urls[1], T.chips[1]);
    setSlotHTML(root, 'def_short', T.def_short);
    setSlotHTML(root, 'def_long', T.def_long);
    setSlotText(root, 'h_features', T.h_features);
    setSlotText(root, 'h_questions', T.h_questions);
    setSlotText(root, 'hint_fold', T.hint_fold);
    setSlotText(root, 'hint_fold2', T.hint_fold);
    setSlotText(root, 'h_family', T.h_family);
    setSlotText(root, 'hint_fold3', T.hint_fold);
    setSlotText(root, 'h_wordbuild', T.h_wordbuild);
    setSlotText(root, 'hint_fold4', T.hint_fold);
    renderListInto(root, 'features', T.features);
    renderListInto(root, 'questions', T.questions);
    setSlotHTML(root, 'example_box', T.example_box);
    setSlotHTML(root, 'family_1', T.family_1);
    setSlotHTML(root, 'family_2', T.family_2);
    renderWordBlocks(root, 'wordbuild_blocks', T.word_blocks);
    renderListInto(root, 'wordbuild_notes', T.word_notes);
    setSlotText(root, 'cta_translate', T.cta_translate);

    var cta = root.querySelector('.po-axis-breath-link');
    if (cta) cta.setAttribute('href', clampStr(cta.getAttribute('href') || PAGE_URL));

    protectDOM(root);
    updateButtons(root, lang);
    wireButtons(root);
    ensureAudioButtons(root, lang);
  }

  function applyLangEverywhere(lang3){
    var lang = storeLang(lang3);
    var roots = document.querySelectorAll(ROOT_SEL);
    Array.prototype.forEach.call(roots, function(root){ renderRoot(root, lang); });
    notifyLocaleChanged();
  }

  function init(){
    applyLangEverywhere(getLang());
    window.addEventListener('po:lexicon-ready', function(){ applyLangEverywhere(getLang()); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.PoKatupirsia9CyclePosoennoialTextsFR_EN_ES_20260328 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: getLang,
    normLang: normLang,
    stopAudio: stopAudio
  };
})();
